import { LiveSendAction } from '../model/liveSendAction';
import { getLinkToken } from './util';
import ApplicationEntity from './appEntity';

let isDisconnectRegisterEvent = false;
let isConnectSlowRegisterEvent = false;

export function tryConnectLiveSendHub(sessionId = '', callback, retryCount = 0) {
    const $ = window.jQuery;
    if (!$) {
        return;
    }

    // can't be deleted, the connection data will be empty array data if deleted this line
    window.LiveSend.client.UpdateSessionStatus = () => {};

    // only call one time and log the signalR disconnect/connection slow event
    if (!isDisconnectRegisterEvent) {
        $.connection.hub.disconnected(() => {
            isDisconnectRegisterEvent = true;
        });
    }

    if (!isConnectSlowRegisterEvent) {
        $.connection.hub.connectionSlow(() => {
            isConnectSlowRegisterEvent = true;
        });
    }

    if ($.signalR.hub.state === $.signalR.connectionState.disconnected) {
        const linkToken = getLinkToken();

        $.connection.hub.qs = { liveSendToken: linkToken, liveSendSessionId: sessionId };

        $.connection.hub.start()
            .done(() => {
                if (callback) callback();
            })
            .fail(() => {
                if (callback && retryCount < 4) {
                    setTimeout(() => {
                        tryConnectLiveSendHub(sessionId, callback, retryCount + 1);
                    }, 500);
                }
            });
    } else if ($.signalR.hub.state === $.signalR.connectionState.reconnecting ||
        $.signalR.hub.state === $.signalR.connectionState.connecting) {
        if (callback && retryCount < 4) {
            setTimeout(() => {
                const countNumber = retryCount + 1;
                tryConnectLiveSendHub(sessionId, callback, countNumber);
            }, 500);
        }
    } else if ($.signalR.hub.state === $.signalR.connectionState.connected) {
        if (callback) callback();
    }
}

export function gotoPage(sessionId, index, event) {
    const linkToken = getLinkToken();
    const sessionAction = new LiveSendAction(sessionId, ApplicationEntity.getInstance().selectedContentId, index, linkToken, event);
    const $ = window.jQuery;
    let retryCount = 0;

    const serverGotoPage = () => {
        try {
            $.connection.LiveSendHub.server.gotoPage(sessionAction)
                .fail(() => {
                    setTimeout(() => {
                        retryCount += 1;
                        if (retryCount < 4) tryConnectLiveSendHub(sessionId, serverGotoPage);
                    }, 500);
                });
        } catch (ex) {
            setTimeout(() => {
                retryCount += 1;
                if (retryCount < 4) tryConnectLiveSendHub(sessionId, serverGotoPage);
            }, 500);
        }
    };

    tryConnectLiveSendHub(sessionId, serverGotoPage);
}

